"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../00_environment/Fonts");

var _countriesData = require("../00_environment/countriesData");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AddressFormComponent = function AddressFormComponent(_ref) {
  var title = _ref.title,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$address = _ref.address,
      inputAddress = _ref$address === void 0 ? {} : _ref$address,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      translatorForNamespace = _ref.translatorForNamespace;

  var t = translatorForNamespace('AddressForm'); // Always use Ecuador as default country

  var address = _objectSpread({}, inputAddress);

  if (!address.country) {
    address.country = 'ec';
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, {
    style: style || {}
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
    style: {}
  }, /*#__PURE__*/_react["default"].createElement("label", {
    style: (0, _Fonts.withDefaultFont)({})
  }, title), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('Address line #1'),
    value: address.line1 || '',
    onChange: function onChange(e, o) {
      return _onChange(_objectSpread(_objectSpread({}, address), {}, {
        line1: o.value
      }));
    },
    style: {
      marginBottom: 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('Address line #2'),
    value: address.line2 || '',
    onChange: function onChange(e, o) {
      return _onChange(_objectSpread(_objectSpread({}, address), {}, {
        line2: o.value
      }));
    },
    style: {
      marginTop: 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('City'),
    value: address.city || '',
    onChange: function onChange(e, o) {
      return _onChange(_objectSpread(_objectSpread({}, address), {}, {
        city: o.value
      }));
    },
    style: {
      marginTop: 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, {
    fluid: true,
    placeholder: t('Zip code'),
    value: address.zip || '',
    onChange: function onChange(e, o) {
      return _onChange(_objectSpread(_objectSpread({}, address), {}, {
        zip: o.value
      }));
    },
    style: {
      marginTop: 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Dropdown, {
    placeholder: t('Country'),
    fluid: true,
    search: true,
    selection: true,
    options: _countriesData.COUNTRY_OPTIONS,
    value: address.country || 'ec',
    onChange: function onChange(e, o) {
      return _onChange(_objectSpread(_objectSpread({}, address), {}, {
        country: o.value
      }));
    },
    style: {
      marginTop: 10,
      marginBottom: 10
    }
  })));
};

var _default = AddressFormComponent;
exports["default"] = _default;